import { decodedObjectsFromPolyline } from '../polyline_util';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const getOptsForCurrentRoutingMode = routingMode => {
  switch (routingMode) {
    case 'mountain-biking':
      return {
        costing: 'bicycle',
        costing_options: {
          bicycle: {
            bicycle_type: 'Mountain',
            use_roads: 0.25,
            use_hills: 1,
            avoid_bad_surfaces: 0.25,
            use_ferry: 0
          }
        }
      };
    case 'bike-touring':
      return {
        costing: 'bicycle',
        costing_options: {
          bicycle: {
            bicycle_type: 'Hybrid',
            use_roads: 0.5,
            use_hills: 0.5,
            avoid_bad_surfaces: 0.5,
            use_ferry: 0
          }
        }
      };
    case 'road-biking':
      return {
        costing: 'bicycle',
        costing_options: {
          bicycle: {
            bicycle_type: 'Road',
            use_roads: 0.75,
            use_hills: 1,
            avoid_bad_surfaces: 0.99,
            use_ferry: 0
          }
        }
      };
    case 'off-road-driving':
      return {
        costing: 'motorcycle',
        costing_options: {
          motorcycle: {
            use_trails: 1, // A riders's desire for adventure in their routes.
            use_ferry: 0
          }
        }
      };
    case 'scenic-driving':
      return {
        costing: 'auto',
        costing_options: {
          auto: {
            use_ferry: 0
          }
        }
      };
    default:
      // hiking
      return {
        costing: 'pedestrian',
        costing_options: {
          pedestrian: {
            max_hiking_difficulty: 6, // pedestrian setting for maximum trail difficulty when routing
            use_ferry: 0
          }
        }
      };
  }
};

// Uses routing library (Valhalla) to get directions from point to point (to point) following OSM segments
// https://valhalla.readthedocs.io/en/latest/api/turn-by-turn/api-reference/
const routePoints = (routingMode, pts, ignoreOrigStart, ignoreOrigEnd) => {
  const firstOrigPt = pts[0];
  const lastOrigPt = pts[pts.length - 1];
  return new Promise((resolve, reject) => {
    const options = {
      directions_type: 'none', // not interested in directions - only need final shape
      locations: pts.map(pt => ({ lon: pt[0], lat: pt[1] })),
      ...getOptsForCurrentRoutingMode(routingMode)
    };
    $.ajax({
      type: 'GET',
      url: 'https://api.mapbox.com/valhalla/v1/route',
      contentType: 'application/json',
      data: {
        access_token: 'pk.eyJ1IjoiYWxsdHJhaWxzIiwiYSI6IkZGaGhGLWsifQ.Fl0FrDM8-xonRV6x2HFqcw',
        json: JSON.stringify(options)
      },
      success: data => {
        // handle bug in valhalla where status code of request is 200, but it responds with error json block
        if (data.status_code && data.status_code !== 200) {
          return reject(data);
        }
        // push polyline from endPt to latLng onto stack
        const polyline = data.trip.legs[0].shape;
        const lngLats = decodedObjectsFromPolyline(polyline, [6, 6]).map(pt => {
          return [Math.round(pt[1] * 1e5) / 1e5, Math.round(pt[0] * 1e5) / 1e5];
        });
        // Ensure pointsData includes first point of original to reduce gap lines
        // This logic is needed because valhalla will route to nearest OSM point, rather than to exact point
        if (!ignoreOrigStart) {
          lngLats.unshift(firstOrigPt);
          // Check for weird valhalla bug where first point returned from routing engine is closing point on line
          // segment's polygon - see French Trail loop in Redwood Regional Park, between Fern trail and Mill trail
          // intersections.
          // Ensure that pointsData[1] is between pointsData[0] and pointsData[2].
          // Note: This logic may need to be adjusted as other cases are found.
          const closeThresh = 1e-4;
          if (
            lngLats.length > 2 &&
            Math.abs(lngLats[0][1] - lngLats[2][1]) <= closeThresh &&
            Math.abs(lngLats[0][0] - lngLats[2][0]) <= closeThresh &&
            Math.abs(lngLats[0][1] - lngLats[1][1]) > closeThresh &&
            Math.abs(lngLats[0][0] - lngLats[1][0]) > closeThresh
          ) {
            lngLats.splice(1, 1);
          }
        }
        if (!ignoreOrigEnd) {
          lngLats.push(lastOrigPt);
        }
        return resolve(lngLats);
      },
      error: error => {
        return reject(error);
      }
    });
  });
};

export { routePoints };
